var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4"},[_c('Account',{attrs:{"AccountId":_vm.$store.getters.user.Account_Id.toString()}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }